/* eslint-disable no-console */
// import fortmaticModule from "@web3-onboard/fortmatic";
// import gnosisModule from "@web3-onboard/gnosis";
import injectedModule from "@web3-onboard/injected-wallets";
// import keepkeyModule from "@web3-onboard/keepkey";
// import keystoneModule from "@web3-onboard/keystone";
// import ledgerModule from "@web3-onboard/ledger";
// import portisModule from "@web3-onboard/portis";
// import torusModule from "@web3-onboard/torus";
// import trezorModule from "@web3-onboard/trezor";
import walletConnectModule from "@web3-onboard/walletconnect";
import coinbaseModule from "@web3-onboard/coinbase";
// import trustModule from "@web3-onboard/trust";
import metamaskSDK from "@web3-onboard/metamask";
import xdefiWalletModule from "@web3-onboard/xdefi";

// import magicModule from "@web3-onboard/magic";
// import dcentModule from "@web3-onboard/dcent";
// import mewModule from "@web3-onboard/mew-wallet";
// import sequenceModule from "@web3-onboard/sequence";
// import tallyHoWalletModule from "@web3-onboard/tallyho";

// import transactionPreviewModule from '@web3-onboard/transaction-preview'

// import web3authModule from '@web3-onboard/web3auth'

import { init } from "@web3-onboard/react";
import { chains, dAppConfigMetaData, isTestnet } from "utils/configs";

// Example key • Replace with your infura key
// const INFURA_KEY = import.meta.env.VITE_INFURA_KEY;

const metamaskSDKWallet = metamaskSDK({
    options: {
        extensionOnly: false,
        dappMetadata: {
            name: dAppConfigMetaData.description,
        },
    },
});

const injected = injectedModule({
    custom: [
        // include custom injected wallet modules here
    ],
    filter: {
        // mapping of wallet labels to filter here
    },
});

const walletLink = coinbaseModule({ darkMode: true });

const wcInitOptions = {
    /**
     * Project ID associated with [WalletConnect account](https://cloud.walletconnect.com)
     */
    projectId: "6e8f5ba2da6f9d2ff0d78fe85d05163f",
    /**
     * Chains required to be supported by all wallets connecting to your DApp
     */
    requiredChains: undefined,
    optionalChains: !isTestnet ? [56, 137, 1, 42161, 10, 8453, 223, 60808] : [1],

    /**
     * Defaults to `appMetadata.explore` that is supplied to the web3-onboard init
     * Strongly recommended to provide atleast one URL as it is required by some wallets (i.e. MetaMask)
     * To connect with WalletConnect
     */
    // dappUrl: "https://app.teleswap.xyz",
};
const walletConnect = walletConnectModule(wcInitOptions);
// const portis = portisModule({
//     // Replace with your apiKey
//     apiKey: "b2b7586f-2b1e-4c30-a7fb-c2d1533b153b",
// });

// const fortmatic = fortmaticModule({
//     // Replace with your apiKey
//     apiKey: "pk_test_886ADCAB855632AA",
// });

// const torus = torusModule();
// const ledger = ledgerModule();
// const trust = trustModule();
// const keepkey = keepkeyModule();
// const keystone = keystoneModule();
// const gnosis = gnosisModule();
// const dcent = dcentModule();
// const mew = mewModule();
// const talltHoWalletSdk = tallyHoWalletModule();
// const web3auth = web3authModule({
//   clientId:
//     'DJuUOKvmNnlzy6ruVgeWYWIMKLRyYtjYa9Y10VCeJzWZcygDlrYLyXsBQjpJ2hxlBO9dnl8t9GmAC2qOP5vnIGo'
// })

// const sequence = sequenceModule({
//     appName: "My app",
// });

const trezorOptions = {
    email: "test@test.com",
    appUrl: "https://www.blocknative.com",
};
// const trezor = trezorModule(trezorOptions);
const xdefiSdk = xdefiWalletModule();

// const magic = magicModule({
//     // Replace with your apiKey
//     apiKey: "pk_live_02207D744E81C2BA",
// });

// const transactionPreview = transactionPreviewModule({});

export default init({
    theme: "dark",
    // transactionPreview,
    apiKey: "fea7d799-8061-4bfe-9edc-f8794fbbb269",
    // An array of wallet modules that you would like to be presented to the user to select from when connecting a wallet.
    wallets: [
        injected,
        metamaskSDKWallet,

        // gnosis,
        // fortmatic,
        // portis,
        walletLink,
        // magic,
        // torus,
        // ledger,
        // trezor,
        walletConnect,
        // trust,
        xdefiSdk,
        // keepkey,
        // keystone,
        // dcent,
        // mew,
        // talltHoWalletSdk,
        // web3auth,
        // sequence
    ],
    // An array of Chains that your app supports
    chains: chains,
    notify: {
        desktop: {
            enabled: false,
            transactionHandler: (transaction) => {
                console.log({ transaction });

                // if (transaction.eventCode === 'txPool') {
                //   return {
                //     type: 'success',
                //     message: 'Your transaction from #1 DApp is in the mempool',
                //   }
                // }
            },
            position: "bottomRight",
        },
        mobile: {
            enabled: false,
            transactionHandler: (transaction) => {
                console.log({ transaction });

                // if (transaction.eventCode === 'txPool') {
                //   return {
                //     type: 'success',
                //     message: 'Your transaction from #1 DApp is in the mempool',
                //   }
                // }
            },
            position: "bottomRight",
        },
    },
    accountCenter: {
        desktop: {
            position: "topRight",
            enabled: false,
            minimal: false,
        },
        mobile: {
            position: "topRight",
            enabled: false,
            minimal: false,
        },
    },
    appMetadata: {
        // The name of your dApp
        name: "TeleSwap",
        // SVG icon string, with height or width (whichever is larger) set to 100% or a valid image URL
        icon: "https://app.teleswap.xyz/logo/teleport/android-chrome-192x192.png",
        // Optional wide format logo (ie icon and text) to be displayed in the sidebar of connect modal. Defaults to icon if not provided
        logo: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1274.38 1269.56"><defs><style>.cls-1{stroke-miterlimit:10;stroke-width:2.35px;fill:url(#linear-gradient);stroke:url(#linear-gradient-2);}.cls-2{fill:url(#linear-gradient-3);}.cls-3{fill:url(#linear-gradient-4);}</style><linearGradient id="linear-gradient" x1="-104.44" y1="228.54" x2="1653.31" y2="1191.38" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#00ca5d"/><stop offset="0.55" stop-color="#0c705b"/><stop offset="0.6" stop-color="#0b6352"/><stop offset="0.78" stop-color="#0a3933"/><stop offset="0.92" stop-color="#082021"/><stop offset="1" stop-color="#08161a"/></linearGradient><linearGradient id="linear-gradient-2" x1="637.19" x2="637.19" y2="1269.56" gradientUnits="userSpaceOnUse"><stop offset="0.02" stop-color="#bababa" stop-opacity="0.4"/><stop offset="0.25" stop-color="#9fa1a2" stop-opacity="0.49"/><stop offset="0.65" stop-color="#575e61" stop-opacity="0.74"/><stop offset="1" stop-color="#08161a"/></linearGradient><linearGradient id="linear-gradient-3" x1="1379.06" y1="1398.5" x2="355.68" y2="335.76" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#00ca5d"/><stop offset="1" stop-color="#fff"/></linearGradient><linearGradient id="linear-gradient-4" x1="1421.45" y1="1357.69" x2="398.07" y2="294.95" xlink:href="#linear-gradient-3"/></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><rect class="cls-1" x="1.17" y="1.17" width="1272.04" height="1267.21" rx="201.52"/><path class="cls-2" d="M880.33,320.65c5.5,2.48,8.15-3.78,2.88-6.84-71-41.08-183.62-83.83-318.8-55.73-22.92,4.76-207.94,46.39-292.23,218.27-8,16.38-81.24,172.71,7.18,332.6C360,954.82,519.33,999.8,522.21,996c2.5-3.26-84-42.25-132.07-135.12a286.79,286.79,0,0,1-29.24-93.69c-.64-4.69,6.55-4.57,8.62.11,43.42,98,149.29,161.72,265,155.94,124-6.2,229.28-90.73,255.84-203.64.9-3.8-4.84-7.66-7.85-5.24C823.65,761.7,741.94,770,681.26,736.19c-51.55-28.68-86.72-87-76.25-145.51,11.86-66.2,80.09-120.73,164.57-125,4.93-.25,3.62-6.86-1.55-8.05a204.22,204.22,0,0,0-83.43-2.05C574.29,476.27,530,583.11,527,590.68a158.71,158.71,0,0,1,11.75-52c12.8-31,33.58-53.52,52.66-69,3.53-2.87-2.29-9.26-6.49-7.13-57.77,29.4-100.1,79.63-113.75,138.51-17.75,76.62,15.53,157.31,83.9,207.07,4.61,3.35,1.83,8.85-3.29,6.49-41.73-19.28-104-58.39-137.3-130.41-54.77-118.41,11.22-227.64,25.25-249.45,81.75-127.07,234.71-143.43,258-145.51C771.9,282.62,834.34,299.93,880.33,320.65Z"/><path class="cls-3" d="M592.2,403.2c-5,1.18-9.41-6-4.79-7.8,38.42-14.91,91.48-28,153.88-23,113,9.08,187.17,72,221.93,109.32,3.81,4.09,9.77,1.49,7.12-3.13a283,283,0,0,0-62.32-75c-35.52-30.24-73.62-47.89-106.26-58.27-5.62-1.79-5.45-8.89.19-7.86,44.72,8.17,100.28,26.27,150.62,66.13a308.33,308.33,0,0,1,66,72.76c61.35,95,72.09,237.46,6.94,353.39C956.66,952.21,812.07,1029.11,654,1029.12c-5.28,0-8.18-7.19-3.28-8.2C708,1009.2,806.15,977.78,879.93,892.1,897.22,872,949.63,809.48,960,715.41c2.57-23.3,18.59-168.48-97.17-259.85C790.52,398.48,689.35,380.23,592.2,403.2Z"/></g></g></svg>`,
        // The description of your app
        description: "TeleSwap enables the seamless bridging of BTC and Runes across blockchains.",
        // The url to a getting started guide for app
        gettingStartedGuide: "https://teleswap.xyz/",
        // url that points to more information about app
        explore: "https://teleswap.xyz/",
        // if your app only supports injected wallets and when no injected wallets detected, recommend the user to install some
        recommendedInjectedWallets: [
            {
                // display name
                name: "MetaMask",
                // link to download wallet
                url: "https://metamask.io",
            },
            { name: "Coinbase", url: "https://wallet.coinbase.com/" },
        ],
        // Optional - but allows for dapps to require users to agree to TOS and privacy policy before connecting a wallet
        agreement: {
            version: "1.0.0",
            termsUrl: "https://docs.teleswap.xyz",
            privacyUrl: "https://docs.teleswap.xyz",
        },
    },
    // example customizing copy
    i18n: {
        en: {
            connect: {
                selectingWallet: {
                    header: "Available Wallets",
                    sidebar: {
                        heading: "",
                        subheading: "Connect your wallet",
                        paragraph:
                            "Connecting your wallet is like “logging in” to Web3. Select your wallet from the options to get started.",
                        IDontHaveAWallet: "I don't have a wallet",
                    },
                },
            },
        },
    },
});
